module.exports = __webpack_public_path__ + "img/8_12.37ff99aa.png";